import { render, staticRenderFns } from "./addHomeCalendar.vue?vue&type=template&id=4b87f2d6"
import script from "./addHomeCalendar.vue?vue&type=script&lang=js"
export * from "./addHomeCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports